// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var GraphqlHelpers = require("../GraphqlHelpers.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var include = TypeUtils.MakeOpaqueIntType({});

var fromInt = include.fromInt;

var toInt = include.toInt;

var compare = include.compare;

function parse(param) {
  return Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: toInt
};

var Id_fromString = include.fromString;

var Id_toString = include.toString;

var Id_decode = include.decode;

var Id_encode = include.encode;

var Id_eq = include.eq;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromInt: fromInt,
  fromString: Id_fromString,
  toInt: toInt,
  toString: Id_toString,
  decode: Id_decode,
  encode: Id_encode,
  compare: compare,
  eq: Id_eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  GraphQL_API: GraphQL_API
};

var Raw = {};

function parse$1(value) {
  var value$1 = value.approvedAt;
  var value$2 = value.rejectedAt;
  var value$3 = value.rejectionReason;
  return {
          id: Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, value.id),
          imageUrl: value.imageUrl,
          approvedAt: !(value$1 == null) ? Caml_option.some(GraphqlHelpers.Datetime.parse(value$1)) : undefined,
          rejectedAt: !(value$2 == null) ? Caml_option.some(GraphqlHelpers.Datetime.parse(value$2)) : undefined,
          rejectionReason: !(value$3 == null) ? value$3 : undefined
        };
}

function serialize(value) {
  var value$1 = value.rejectionReason;
  var rejectionReason = value$1 !== undefined ? value$1 : null;
  var value$2 = value.rejectedAt;
  var rejectedAt = value$2 !== undefined ? Curry._1(GraphqlHelpers.Datetime.serialize, Caml_option.valFromOption(value$2)) : null;
  var value$3 = value.approvedAt;
  var approvedAt = value$3 !== undefined ? Curry._1(GraphqlHelpers.Datetime.serialize, Caml_option.valFromOption(value$3)) : null;
  var value$4 = value.imageUrl;
  var value$5 = value.id;
  var value$6 = Curry._1(toInt, value$5);
  return {
          id: value$6,
          imageUrl: value$4,
          approvedAt: approvedAt,
          rejectedAt: rejectedAt,
          rejectionReason: rejectionReason
        };
}

function verifyArgsAndParse(_CommonTypes_ProfilePicture, value) {
  return parse$1(value);
}

function verifyName(param) {
  
}

function compare$1(param, param$1) {
  return Curry._2(compare, param$1.id, param.id);
}

function eq(param, param$1) {
  return Curry._2(compare, param.id, param$1.id) === "equal_to";
}

var query = "fragment CommonTypes_ProfilePicture on ProfilePicture   {\nid  \nimageUrl: pictureUrl  \napprovedAt  \nrejectedAt  \nrejectionReason  \n}\n";

exports.Id = Id;
exports.Raw = Raw;
exports.query = query;
exports.parse = parse$1;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.compare = compare$1;
exports.eq = eq;
/* include Not a pure module */
